<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../helpers/numeros";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      taller:[],
      ventas: [],
      agresos: [],
      adelantoTaller:[],
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalPendiente: 0,
        totalPagado: 0,
        vendedor: "",
        total: "",
        state: true,
        id: 0,
      },
      estadoCredito: false,
      formFactura: {
        fecha_emision: "",
        fecha_certificacion: "",
        dataCert: "",
        serie: "",
        number: "",
        uuid: "",
      },
      egresos: [],
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
      userReport:null,
      detalleProducto : [],
      detalleServicio :[],
        arqueo :{},
        creditos : [],
        creditosTaller:[],
        totalDeudaVenta:0,
        totalDeudaTaller:0    
    };

  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    formatQuetzales (amount) {
        let num = parseFloat(amount), formatted
        formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        return amount = 'Q ' + formatted
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
    //   let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "clientes/get_saldos?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
        // console.log(response)
        // console.log(response);
            // this.arqueo = response.data.arqueo;
            this.creditos = response.data.SaldosVenta;
            this.creditosTaller = response.data.SaldosVentaTaller;
            this.userReport = response.data.cliente;
            this.totalDeudaVenta = response.data.totalSaldoCredito || 0;
            this.totalDeudaTaller = response.data.totalSaldoCreditoTaller || 0;

            // console.log(this.creditos, this.creditosTaller, this.userReport)
        
        });
    },
    calcularTotal() {
      let total = 0;
      this.detalleServicio.forEach(item => {
        total += item.subtotal_servicio;
      });
      return this.money(total);
    },
    calcularTotalRepuestos() {
      let total = 0;
      this.detalleProducto.forEach(item => {
        total += item.subtotal_venta;
      });
      return this.money(total);
    },
    formatoPresentacion(date){
        return moment(date).locale('es').format('LL'); 
    },
    isFechaVencida(fechaMaximaPago) {
      const hoy = new Date();
      const fechaPago = new Date(fechaMaximaPago);
      return fechaPago < hoy; // Retorna true si la fecha máxima de pago es menor que la fecha actual
    },
    isFechaProxima(fechaMaximaPago) {
      const hoy = new Date();
      const fechaPago = new Date(fechaMaximaPago);
      const diferenciaDias = (fechaPago - hoy) / (1000 * 3600 * 24); // Diferencia en días
      return diferenciaDias <= 7 && diferenciaDias > 0; // Retorna true si la fecha está dentro de los próximos 7 días
    }
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  },
};
</script>
<style></style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mt-4">
      <div class="col d-print-none">
        <router-link
          :to="{
            name: 'Clientes',
          }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
            ref="buttonImprimir"
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
            ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <div class="card-body">
            <div class="row">
    <div class="col-12 text-center">
        <h4 style="font-weight: bold; color: #424242;">Taller de REPARACIÓN ARIEL</h4>
        <p style="margin: 0;">
            <i class="bx bx-phone" style="color: #388e3c;"></i>&nbsp;42837238
            <br />
            <i class="bx bx-map" style="color: #388e3c;"></i>&nbsp;Compa Jutiapa
        </p>
        <hr style="border-top: 1px solid #ddd;">
        <h5 style="color: #388e3c; font-weight: bold; margin-top: 10px;">
            Cliente: {{ userReport?.persona.nombre_persona }}
        </h5>
        <div style="margin-top: 10px;">
            <h6 style="font-weight: bold; color: #424242;">
                Total Deuda:
                <span style="color: #d32f2f;"> {{ formatQuetzales(parseFloat(totalDeudaVenta) + parseFloat(totalDeudaTaller)) }}</span>
            </h6>
        </div>
    </div>
</div>

            <br />
           
           
                          <br>
                            <h4><strong>Creditos Pendientes De Venta</strong></h4>
                            <br>
                            <table class="table" border="2">
                                <thead>
                                    <tr style="background-color: #424242; color: white;">
                                        <th><i class="bx bxs-grid-alt"></i>&nbsp;&nbsp;No. venta</th>
                                        <th><i class="bx bxs-grid-alt"></i>&nbsp;&nbsp;Fecha Venta</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Fecha Maxima Pago</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Total Deuda</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Saldo Pendiente</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Detalle Productos</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Detalle Servicios</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in creditos" v-bind:key="index" 
                                        :class="{
                                            'vencido': isFechaVencida(item.fecha_credito_v), 
                                            'no-vencido': !isFechaVencida(item.fecha_credito_v), 
                                            'proximo-vencido': isFechaProxima(item.fecha_credito_v)
                                        }">
                                        <td>{{ item.no_ducumento_v }}</td>
                                        <td>{{ item.fecha_venta_v }}</td>
                                        <td>{{ item.fecha_credito_v }}</td>
                                        <td>{{ formatQuetzales(item.total_v) }}</td>
                                        <td>{{ formatQuetzales(item.saldo_credito_v) }}</td>
                                        <td>
                                            <span v-for="(detalle, i) in item.detalle_ventas" :key="i">
                                                {{ detalle.producto.nombre_producto }}
                                                <span v-if="i !== item.detalle_ventas.length - 1">, </span>
                                            </span>
                                        </td>
                                        <td>
                                            <span v-for="(detalle, i) in item.detalle_servicio_vs" :key="i">
                                                {{ detalle.servicio.nombre_servicio }}
                                                <span v-if="i !== item.detalle_servicio_vs.length - 1">, </span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                          <br>
                            <h4><strong>Creditos Pendientes De Taller</strong></h4>
                            <br>
                            <table class="table" border="2">
                                <thead>
                                    <tr style="background-color: #424242; color: white;">
                                        <th><i class="bx bxs-grid-alt"></i>&nbsp;&nbsp;No. Servicio</th>
                                        <th><i class="bx bxs-grid-alt"></i>&nbsp;&nbsp;Fecha Recepcion</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Fecha Maxima Pago</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Total Deuda</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Saldo Pendiente</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Detalle Productos</th>
                                        <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Detalle Servicios</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in creditosTaller" v-bind:key="index" 
                                        :class="{
                                            'vencido': isFechaVencida(item.fecha_credito), 
                                            'no-vencido': !isFechaVencida(item.fecha_credito), 
                                            'proximo-vencido': isFechaProxima(item.fecha_credito)
                                        }">
                                        <td>{{ item.no_servicio }}</td>
                                        <td>{{ item.fecha_entrada }}</td>
                                        <td>{{ item.fecha_credito }}</td>
                                        <td>{{ formatQuetzales(item.total) }}</td>
                                        <td>{{ formatQuetzales(item.saldo_credito) }}</td>
                                        <td>
                                            <span v-for="(detalle, i) in item.detalle_prod_servs" :key="i">
                                                {{ detalle.producto.nombre_producto }}
                                                <span v-if="i !== item.detalle_prod_servs.length - 1">, </span>
                                            </span>
                                        </td>
                                        <td>
                                            <span v-for="(detalle, i) in item.detalle_serv_servs" :key="i">
                                                {{ detalle.servicio.nombre_servicio }}
                                                <span v-if="i !== item.detalle_serv_servs.length - 1">, </span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                          
            
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
   .table {
        width: 100%;
        border-collapse: collapse;
        font-family: 'Arial', sans-serif;
        font-size: 12px; /* Reducción del tamaño de fuente */
    }

    .table th, .table td {
        padding: 6px; /* Ajuste del padding para mayor compacidad */
        text-align: left;
    }

    .table th {
        background-color: #424242; /* Gris oscuro para encabezados */
        color: white; /* Texto blanco para contraste */
        font-weight: bold;
    }

    .table td {
        border: 1px solid #ddd; /* Bordes ligeros para un toque elegante */
    }
   .vencido {
        background-color: #B71C1C; /* Rojo oscuro suave */
        color: white;
    }
    .no-vencido {
        background-color: #E0F7FA; /* Verde agua claro */
        color: black;
    }
    .proximo-vencido {
        background-color: #FFF3E0; /* Beige claro */
        color: black;
    }

    /* Ajuste general de estilos de tabla */
    table {
        width: 100%;
        border-collapse: collapse;
        font-family: 'Arial', sans-serif;
        font-size: 14px;
    }
    
    th, td {
        padding: 10px;
        text-align: left;
    }

    th {
        background-color: #424242; /* Gris oscuro para encabezados */
        color: white; /* Texto blanco para contraste */
        font-weight: bold;
    }

    td {
        border: 1px solid #ddd; /* Bordes ligeros para un toque elegante */
    }
       /* Estilos generales de la página */
       body {
        font-family: Arial, sans-serif;
    }

    @media print {
    body {
        font-family: Arial, sans-serif;
        font-size: 12px;
    }

    .vencido {
        background-color: #B71C1C !important; /* Rojo oscuro suave */
        color: white !important;
    }

    .no-vencido {
        background-color: #E0F7FA !important; /* Verde agua claro */
        color: black !important;
    }

    .proximo-vencido {
        background-color: #FFF3E0 !important; /* Beige claro */
        color: black !important;
    }

    .table th, .table td {
        border: 1px solid black !important;
        color: black !important;
        background-color: #f2f2f2 !important;
    }

    /* Ocultar enlaces y botones en la impresión */
    .btn, a[href] {
        display: none !important;
    }
}
</style>
